import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core";


const RatingIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>

            <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 400 630">
                <g id="star_24px" transform="translate(-2 -50)">
                    <path id="icon_toggle_star_24px" fill={'#FED60A'} d="M252,384.3l154.5,93.3l-41-175.8L502,183.5l-179.8-15.3L252,2.5l-70.3,165.8
                        L2,183.5l136.5,118.2l-41,175.8L252,384.3z"/>
                </g>
            </svg>

        </SvgIcon>
    )
};

export default RatingIcon;